import { render, staticRenderFns } from "./DrawableObjectMenu.vue?vue&type=template&id=b6894cc4&scoped=true&"
import script from "./DrawableObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./DrawableObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DrawableObjectMenu.vue?vue&type=style&index=0&id=b6894cc4&lang=scss&scoped=true&"
import style1 from "./DrawableObjectMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6894cc4",
  null
  
)

export default component.exports